import { useState } from "react";
import { useTranslation } from "react-i18next";
import { hotComics } from "@/mocks/comics";

export default function FeatureGrid() {
  const { t } = useTranslation();
  const [expandedIndex, setExpandedIndex] = useState(0);

  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            {t("feature.title", "🔥 本周热门推荐")}
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            {t("feature.subtitle", "大家都在追的韩漫")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {hotComics.map((comic, index) => (
            <div
              key={comic.id}
              onMouseEnter={() => setExpandedIndex(index)}
              className={`relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 group ${
                expandedIndex === index ? "md:col-span-2" : "md:col-span-1"
              }`}
              style={{ aspectRatio: expandedIndex === index ? "16/9" : "3/4" }}
            >
              <img
                src={comic.imageUrl}
                alt={comic.title}
                title={comic.title + " - 在线漫画韩漫"}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-500 text-white text-xs font-medium mb-2">
                  {comic.category}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white leading-snug">
                  {comic.title}
                </h3>
                <p className="mt-2 text-sm text-gray-300 leading-relaxed line-clamp-2">
                  {comic.author}
                </p>
                {expandedIndex === index && (
                  <p className="mt-2 text-sm text-gray-400 leading-relaxed line-clamp-2">
                    {comic.desc}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}